interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ index, eyebrow, title, desc }: SectionHeadingProps) {
  return (
    <div className="mb-6 md:mb-9">
      <div className="flex items-center gap-3">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-foreground-950 font-label text-[11px] font-medium text-background-50">
          {index}
        </span>
        <span className="font-label text-xs tracking-[0.22em] text-foreground-500 uppercase">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px]">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-[15px]">{desc}</p>
      ) : null}
    </div>
  );
}